import { useCallback } from 'react'
import axios from 'axios'

const useFinancialClient = () => {
  const getFinancialTickets = useCallback(async (data, config) => axios.post('/financial/search', data, config).then((response) => (
    response?.data ? response : { data: { ...response } })), [])

  const downloadSummaryFinancial = useCallback(async (data) => axios.post('/financial/export/excel', data, {
    responseType: 'arraybuffer',
  }).then((response) => (response?.data ? response : { data: { ...response } })), [])

  const getBilletNotificationOptions = useCallback(async () => axios.get('/financial/BilletNotificationOptions'), [])

  const updateBilletNotification = useCallback(async (data) => axios.post('/financial/UpdateBilletNotification', data).then((response) => (
    response?.data ? response : { data: { ...response } })), [])

  const dueDateRenewaln = useCallback(async (billingId, newDueDate) => axios.get(`/financial/DueDateRenewal?billingId=${billingId}&newDueDate=${newDueDate}`), [])

  const checkForNewBillet = useCallback(async (item) => axios.get(`/financial/CheckForNewBillet?payerDocumentNumber=${item.payer.documentNumber}&policyNumber=${item.documents[0].number}&installmentNumber=${item.documents[0].installmentNumber}&billingId=${item.billingId}`), [])

  const getAllTickets = useCallback((policyNumber) => axios.get(`financial/billet/download/all?documentNumber=${policyNumber}&base64=true`), [])

  const getAllTicketsInfo = useCallback((policyNumber) => axios.get(`financial/billet/download/all/info?documentNumber=${policyNumber}`), [])

  const getAdvancedEmailPreferences = useCallback(async () => axios.get('/user/GetAdvancedEmailPreferences'), [])

  const updateAdvancedEmailPreferences = useCallback(async (data) => axios.post('/user/updateAdvancedEmailPreferences', data).then((response) => (
    response?.data ? response : { data: { ...response } })), [])

  const unsubscribeEmail = useCallback(async (emailId) => axios.post(`/user/UnsubscribeEmail?emailId=${emailId}`).then((response) => (
    response?.data ? response : { data: { ...response } })), [])

  return useCallback(() => ({
    dueDateRenewaln,
    getFinancialTickets,
    downloadSummaryFinancial,
    updateBilletNotification,
    getBilletNotificationOptions,
    getAllTickets,
    checkForNewBillet,
    getAdvancedEmailPreferences,
    updateAdvancedEmailPreferences,
    unsubscribeEmail,
    getAllTicketsInfo,
  }), [
    dueDateRenewaln,
    getFinancialTickets,
    downloadSummaryFinancial,
    updateBilletNotification,
    getBilletNotificationOptions,
    getAllTickets,
    checkForNewBillet,
    getAdvancedEmailPreferences,
    updateAdvancedEmailPreferences,
    unsubscribeEmail,
    getAllTicketsInfo,
  ])
}

export default useFinancialClient
